import { pricingConfigStrings } from './strings';
import {
  CreatePricingConfigPayload,
  PricingConfigFormErrors,
  PricingConfigFormValues,
} from './types';

/**
 * Client-side validation for the pricing-config form: the per-recipient rate
 * must be a number greater than 0 and the minimum quantity a whole number of
 * at least 1. Pure so it can be unit-tested without rendering.
 */
export const validatePricingConfigForm = (
  values: PricingConfigFormValues,
): PricingConfigFormErrors => {
  const errors: PricingConfigFormErrors = {};

  const credits = Number(values.creditsPerRecipient);
  if (
    values.creditsPerRecipient.trim() === '' ||
    Number.isNaN(credits) ||
    credits <= 0
  ) {
    errors.creditsPerRecipient =
      pricingConfigStrings.form.errors.creditsPerRecipient;
  }

  const minQuantity = Number(values.minQuantity);
  if (
    values.minQuantity.trim() === '' ||
    !Number.isInteger(minQuantity) ||
    minQuantity < 1
  ) {
    errors.minQuantity = pricingConfigStrings.form.errors.minQuantity;
  }

  return errors;
};

/** Converts validated form values into the API payload. */
export const toPricingConfigPayload = (
  values: PricingConfigFormValues,
): CreatePricingConfigPayload => ({
  assetKind: values.assetKind,
  creditsPerRecipient: Number(values.creditsPerRecipient),
  minQuantity: Number(values.minQuantity),
  isActive: values.isActive,
});
